module.exports = __webpack_public_path__ + "img/image-2.c7755eb3.png";